import { Group } from '../../clients/aasServerClient.generated';
import {
    ActionTypeNames,
    AssignGroupsWorkspacesAction,
    ClearSingleGroupAction,
    CopySingleGroupAction,
    CreateSingleGroupAction,
    FetchAllGroupsAction,
    FetchGroupsPerWorkspaceAction,
    FetchSingleGroupAction,
    FetchTableGroupsAction,
    GroupsAction,
    NewSingleGroupAction,
    SavedSingleGroupAction,
    SaveSingleGroupAction,
    StoreAllGroupsAction,
    StoreSingleGroupAction,
    StoreGroupsPerWorkspaceAction,
    StoreTableGroupsAction,
    FetchTableGroupsNoSearchAction,
} from './actions';

export function fetchTableGroups(): FetchTableGroupsAction {
    return {
        type: ActionTypeNames.FetchTableGroups
    };
}

export function fetchTableGroupsNoSearch(): FetchTableGroupsNoSearchAction {
    return {
        type: ActionTypeNames.FetchTableGroupsNoSearch
    };
}

export function fetchAllGroups(): FetchAllGroupsAction {
    return {
        type: ActionTypeNames.FetchAllGroups
    };
}

export function fetchGroupsPerWorkspace(ids: string[]): FetchGroupsPerWorkspaceAction{
    return {
        ids,
        type: ActionTypeNames.FetchGroupsPerWorkspace
    };
}
export function fetchSingleGroup(id: string): FetchSingleGroupAction {
    return {
        id,
        type: ActionTypeNames.FetchSingleGroup
    };
}
export function newSingleGroup(): NewSingleGroupAction {
    return {
        type: ActionTypeNames.NewSingleGroup
    };
}

export function copySingleGroup(id: string): CopySingleGroupAction {
    return {
        id,
        type: ActionTypeNames.CopySingleGroup
    };
}

export function storeSingleGroup(group: Partial<Group>): StoreSingleGroupAction {
    return {
        group,
        type: ActionTypeNames.StoreSingleGroup,
    };
}

export function saveSingleGroup(
    group: Partial<Group>,
    workspaces?: Array<{ id: string, value: boolean }>
): SaveSingleGroupAction {
    return {
        group,
        type: ActionTypeNames.SaveSingleGroup,
        workspaces,
    };
}

export function createSingleGroup(
    group: Partial<Group>,
    workspaces?: Array<{ id: string, value: boolean }>
): CreateSingleGroupAction {
    return {
        group,
        type: ActionTypeNames.CreateSingleGroup,
        workspaces
    };
}

export function clearSingleGroup(): ClearSingleGroupAction {
    return {
        type: ActionTypeNames.ClearSingleGroup,
    };
}

export function savedSingleGroup(): SavedSingleGroupAction {
    return {
        type: ActionTypeNames.SavedSingleGroup,
    };
}

function groupsActionCreator<T extends ActionTypeNames>(type: T) {
    return (ids: string[]): GroupsAction<T> => {
        return {
            groupIds: ids,
            type,
        };
    };
}

export function storeTableGroups(groups: Group[]): StoreTableGroupsAction {
    return {
        groups,
        type: ActionTypeNames.StoreTableGroups,
    };
}

export function storeAllGroups(groups: Group[]): StoreAllGroupsAction {
    return {
        groups,
        type: ActionTypeNames.StoreAllGroups,
    };
}

export function storeGroupsPerWorkspace(groups: Group[]): StoreGroupsPerWorkspaceAction {
    return {
        groups,
        type: ActionTypeNames.StoreGroupsPerWorkspace,
    };
}
export const deleteGroups = groupsActionCreator(ActionTypeNames.DeleteGroups);

export function assignGroupsWorkspaces(
    groupIds: string[],
    workspaceIds: string[]
): AssignGroupsWorkspacesAction {
    return {
        groupIds,
        type: ActionTypeNames.AssignGroupsWorkspaces,
        workspaceIds,
    };
}
